(function () {
    const initCollapsibleContent = () => {
        // Cerrar todos los bloques al iniciar
        $(".collapsible-content-item")
            .removeClass("active")
            .find(".collapsible-content-block__description")
            .hide(); // Oculta las descripciones

        $(".collapsible-content-summery")
            .attr("tabindex", "0")
            .unbind("click keydown")
            .on("click", function () {
                toggleCollapsible($(this));
            })
            .on("keydown", function (event) {
                if (event.key === "Enter" || event.keyCode === 13) {
                    event.preventDefault();
                    toggleCollapsible($(this));
                }
            });
    };

    const toggleCollapsible = ($currentSummary) => {
        const $parentItem = $currentSummary.closest(".collapsible-content-item");
        const $section = $currentSummary.closest(".collapsible-content-box");

        const isCurrentlyActive = $parentItem.hasClass("active");

        $section
            .find(".collapsible-content-item.active")
            .removeClass("active")
            .find(".collapsible-content-block__description")
            .stop()
            .slideUp(300);

        if (!isCurrentlyActive) {
            $parentItem.addClass("active");
            $currentSummary
                .next(".collapsible-content-block__description")
                .stop()
                .slideDown(300);
        }
    };

    document.addEventListener("shopify:section:load", function () {
        initCollapsibleContent();
    });

    document.addEventListener("DOMContentLoaded", function () {
        initCollapsibleContent();
    });
})();

